import React from 'react';
import { motion } from 'framer-motion';
const faqs = [{
  q: 'Do I have to buy specific brands?',
  a: 'No, the guide teaches you what ingredients to look for so you can choose the option you prefer.'
}, {
  q: 'Is it safe if I exercise?',
  a: "It's ideal; exercise depletes minerals even faster, and this plan protects you."
}, {
  q: 'How long does it take to see results?',
  a: 'Symptoms of cellular dehydration improve within 24 hours; deeper energy stabilizes in the first 10–14 days.'
}, {
  q: 'Will this break my fast?',
  a: 'The guide includes options that respect intermittent fasting.'
}];
export function FAQ() {
  return <section className="py-24 px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-50">
      <div className="text-center mb-16" data-id="element-51">
        <h2 className="text-4xl font-bold mb-6" data-id="element-52">Frequently Asked Questions</h2>
      </div>

      <div className="space-y-6" data-id="element-53">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white p-6 rounded-2xl border border-forest/10" data-id="element-54">
            <h3 className="text-xl font-bold text-forest mb-2" data-id="element-55">{faq.q}</h3>
            <p className="text-charcoal/80" data-id="element-56">{faq.a}</p>
          </motion.div>)}
      </div>
    </section>;
}